import {
    Box,
    Typography,
    BoxProps,
    CircularProgressProps,
} from "@mui/material";
import CustomCircularProgress from "../CustomCircularProgress/CustomCircularProgress";

type CircularProgressWithRatioProps = {
    boxProps?: BoxProps;
    value: number;
    ratio: {
        num: number;
        den: number;
    };
    circularProgressProps?: { circualcolor?: string } & CircularProgressProps;
};

export default function CircularProgressWithRatio({
    boxProps,
    value,
    ratio,
    circularProgressProps,
}: CircularProgressWithRatioProps) {
    const { sx, ...otherBoxProps } = boxProps || {};
    return (
        <Box
            sx={{
                display: "flex",
                width: "5.625rem",
                alignItems: "center",
                gap: "0.5rem",
                ...sx,
            }}
            {...otherBoxProps}
        >
            <CustomCircularProgress {...circularProgressProps} value={value} />
            <Typography
                sx={{
                    color: "#023",
                    leadingTrim: "both",
                    textEdge: "cap",
                    fontFamily: "Roboto",
                    fontSize: "1rem",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "normal",
                }}
            >
                {`${ratio.num} / ${ratio.den}`}
            </Typography>
        </Box>
    );
}
